import { useEffect } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay, EffectFade } from 'swiper/modules';
import FutureTechnology from '../../assets/image34.jpeg';
import DSC_0341 from '../../assets/equipo/DSC_0341.jpg';
import DSC_0343 from '../../assets/equipo/DSC_0343.jpg';
import DSC_0344 from '../../assets/equipo/DSC_0344.jpg';
import DSC_0348 from '../../assets/equipo/DSC_0348.jpg';
import DSC_0349 from '../../assets/equipo/DSC_0349.jpg';
import DSC_0350 from '../../assets/equipo/DSC_0351.jpg';
import DSC_0351 from '../../assets/equipo/DSC_0350.jpg';
import ContactFloating from "../../components/contact-floating";
import CountUp from 'react-countup';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import './Equipo.styles.scss';

const Equipo = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Array de imágenes del equipo (reemplaza con tus imágenes reales)
    const teamImages = [
        {
            id: 1,
            image: DSC_0341,
            caption: "Nuestro equipo en acción"
        },
        {
            id: 2,
            image: DSC_0344, // Reemplaza con imagen real
            caption: "Expertos en mecánica"
        },
        {
            id: 3,
            image: DSC_0349, // Reemplaza con imagen real
            caption: "Tecnología de última generación"
        },
        {
            id: 4,
            image: DSC_0350, // Reemplaza con imagen real
            caption: "Compromiso con la calidad"
        }
    ];

    return (
        <div className="equipo-page">
            <section className="equipo-hero section animate__animated animate__fadeIn">
                <div className="container equipo-container">
                    <h1 className="section-title">Nuestro Equipo de Profesionales</h1>
                    
                    <div className="equipo-content">

                        {/* Carousel del Equipo */}
<div className="team-info">
    <div className="team-carousel-container">
        <Swiper
            modules={[Pagination, Navigation, Autoplay, EffectFade]}
            spaceBetween={0}
            slidesPerView={1}
            effect="fade"
            fadeEffect={{ crossFade: true }}
            navigation={{
                nextEl: '.team-button-next',
                prevEl: '.team-button-prev',
            }}
            pagination={{
                clickable: true,
                dynamicBullets: true,
            }}
            autoplay={{
                delay: 4500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            }}
            loop={true}
            speed={1000}
            className="team-swiper"
        >
            {teamImages.map((item) => (
                <SwiperSlide key={item.id}>
                    <div className="team-slide">
                        <img
                            src={item.image}
                            alt={item.caption}
                            className="team-slide-image"
                        />
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>

        {/* Overlay simplificado con contenido mínimo */}
        <div className="team-overlay-content">
            <div className="overlay-inner">
                <h2 className="overlay-title">
                    El mejor equipo de mecánicos
                </h2>

                <p className="overlay-description">
                    Profesionales dedicados a brindarte un servicio de calidad excepcional
                </p>

                <button 
                    className="contact-button"
                    onClick={() =>
                        window.open(
                            'https://wa.me/5492635000305?text=Hola,%20quisiera%20consultar%20sobre%20servicios%20técnicos',
                            '_blank'
                        )
                    }
                >
                    <i className="ri-whatsapp-line"></i>
                    <span>Contáctanos</span>
                </button>
            </div>
        </div>

        {/* Botones de navegación del carousel */}
        <div className="team-button-prev">
            <i className="ri-arrow-left-s-line"></i>
        </div>
        <div className="team-button-next">
            <i className="ri-arrow-right-s-line"></i>
        </div>
    </div>
</div>
                    </div>
                    {/* Estadísticas */}
                        <div className="stats-group">
                            <div className="stats-card">
                                <h3 className="card-title">
                                    <CountUp
                                        start={0}
                                        end={2500}
                                        duration={3}
                                        prefix="+"
                                    />
                                </h3>
                                <p className="description">Vehículos reparados</p>
                            </div>
                        </div>

                    {/* Sección adicional de características del equipo */}
                    <div className="team-features">
                        <div className="features-grid">
                            <div className="feature-item">
                                <div className="feature-icon">
                                    <i className="ri-user-star-line"></i>
                                </div>
                                <h3>Experiencia</h3>
                                <p>Más de 60 años de experiencia en el sector automotor</p>
                            </div>
                            
                            <div className="feature-item">
                                <div className="feature-icon">
                                    <i className="ri-tools-line"></i>
                                </div>
                                <h3>Tecnología</h3>
                                <p>Equipamiento moderno y herramientas de última generación</p>
                            </div>
                            
                            <div className="feature-item">
                                <div className="feature-icon">
                                    <i className="ri-shield-check-line"></i>
                                </div>
                                <h3>Confiabilidad</h3>
                                <p>Trabajo garantizado y compromiso con la calidad</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <ContactFloating />
        </div>
    );
};

export default Equipo;